import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import { ContentCard } from "./ContentCard";
import { Content } from "../../../common/types";

const ContentGrid = ({ content }: {content: Content[]}) => {
    return (
            <SimpleGrid
                columns={{
                    base: 1,
                    md: 2,
                    lg: content.length >= 3 ? 4 : 2,
                }}
                spacing={4}
                placeContent="center"
            >
                {content.map((c) => (
                    <ContentCard key={c._id} content={c} />
                ))}
            </SimpleGrid>
    );
};

export default ContentGrid;
